import { colorDotCodeMap } from "../constants/colors";
import { getEntityProductRef } from "../functions/MountingRails";
import { NO_PRICE, NO_PRODUCT_REF, PRODUCT_DOESNT_EXIST, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
import { MOUNTING_RAIL_TYPE_CODE } from "../constants";
/**
 * Get the price of a product
 *
 * @param product
 */
export const getPriceOfProduct = (product) => {
    var _a, _b;
    const price = (_b = (_a = product.content) === null || _a === void 0 ? void 0 : _a.priceInformation) === null || _b === void 0 ? void 0 : _b.salesPrice[0].priceInclTax;
    if (!price)
        throw new Error(NO_PRICE);
    return price;
};
/**
 * Get the color of a product
 *
 * @param product
 */
export const getColorOfProduct = (product) => {
    var _a, _b;
    const dotCodeInProduct = (_a = product === null || product === void 0 ? void 0 : product.content) === null || _a === void 0 ? void 0 : _a.colourDotCode;
    if (!dotCodeInProduct)
        return null;
    return (((_b = Object.entries(colorDotCodeMap).find((mapping) => mapping[1] === dotCodeInProduct)) === null || _b === void 0 ? void 0 : _b[0]) || null);
};
/**
 * Get the majority color of products
 *
 * @param products
 */
export const getMajorityColorOfProducts = (products) => {
    const colorCounts = {};
    products.forEach((product) => {
        const colorOfProduct = getColorOfProduct(product);
        if (!colorOfProduct)
            return;
        const previousCount = colorCounts[colorOfProduct];
        colorCounts[colorOfProduct] = previousCount ? previousCount + 1 : 1;
    });
    const highestCount = Math.max(...Object.values(colorCounts));
    return Object.keys(colorCounts).find((color) => colorCounts[color] === highestCount);
};
/**
 * Selects product by id
 *
 * @param products
 * @param productId
 */
export const getProductById = (products, productId) => {
    const product = products.find((product) => { var _a; return ((_a = product.content) === null || _a === void 0 ? void 0 : _a.itemNoGlobal) === productId; });
    if (!product)
        throw new Error(PRODUCT_DOESNT_EXIST);
    return product;
};
/**
 * Select severeal products by id
 * @param products
 * @param productIds
 */
export const getProductsByIds = (products, productIds) => products.filter(({ content }) => (content === null || content === void 0 ? void 0 : content.itemNoGlobal) && productIds.includes(content === null || content === void 0 ? void 0 : content.itemNoGlobal));
/**
 * Select mounting rail products
 * @param products
 */
export const getMountingRailsProducts = (products) => products.filter(({ content }) => (content === null || content === void 0 ? void 0 : content.typeCode) === MOUNTING_RAIL_TYPE_CODE);
/**
 * Select product data by entity
 *
 * @param products
 * @param entity
 */
export const getEntityProductData = (products, entity) => {
    const entityProductRef = getEntityProductRef(entity);
    if (!entityProductRef)
        throw new Error(NO_PRODUCT_REF);
    return getProductById(products, entityProductRef);
};
/**
 * Takes an array of products and returns the total price of the products
 *
 * @param products
 */
export const getPriceOfProducts = (products) => products.reduce((accumulatedPrice, product) => accumulatedPrice + getPriceOfProduct(product), 0);
/**
 * Compares arrays of products and returns the ones with the lowest price
 *
 * @param productArrays
 */
export const findCheapestProductArrays = (productArrays) => {
    const priceOfCheapestArray = productArrays.reduce((lowestPriceSoFar, currentArray) => {
        const priceOfCurrentArray = getPriceOfProducts(currentArray);
        return priceOfCurrentArray < lowestPriceSoFar
            ? priceOfCurrentArray
            : lowestPriceSoFar;
    }, Infinity);
    return productArrays.filter((productArray) => getPriceOfProducts(productArray) === priceOfCheapestArray);
};
/**
 * Takes a product and returns a product number
 *
 * @param product
 */
export const getProductRefFromProduct = (product) => {
    var _a, _b;
    if (!((_a = product.content) === null || _a === void 0 ? void 0 : _a.itemNoGlobal))
        throw new Error(NO_PRODUCT_REF);
    return (_b = product === null || product === void 0 ? void 0 : product.content) === null || _b === void 0 ? void 0 : _b.itemNoGlobal;
};
